import Axios from 'axios'
import React, { useState } from 'react'
import { CardActions, CreateButton, ExportButton } from 'react-admin'
import { auth0 } from '../auth/client'

const UserListActions = ({ basePath, permissions, total }) => {
  const [loading, setLoading] = useState(false)

  const handleExport = async () => {
    try {
      console.log('Export users started')

      setLoading(true)
      const response = await Axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/export`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${await auth0.getTokenSilently()}`,
          },
          responseType: 'blob',
        },
      )

      const downloadUrl = URL.createObjectURL(response.data)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'export.csv'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(downloadUrl)

      console.log('Export users successful')
    } catch (error) {
      console.log('Export users unknown error', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <CardActions>
      {permissions?.includes('create:users') && <CreateButton basePath={basePath} />}

      {permissions?.includes('read:users') && (
        <ExportButton
          label={loading ? 'Exporting...' : 'Export'}
          disabled={total === 0 || loading}
          onClick={handleExport}
        />
      )}
    </CardActions>
  )
}

export default UserListActions
